import * as API from "utils/api"
import { APIResponse } from "./types"

const InvestmentSymbolList: API.RequestAPI<APIResponse.Res | {}> = async (
  params?: object,
  headers?: object
) => {
  return await API.request(
    "GET",
    "Equity/Message/InvestmentSymbolList",
    params,
    headers
  )
}

export default {
  InvestmentSymbolList,
}
